import { cast, LocalDateTime, maybe } from "@flockcover/flock-svc-core-types"
import * as t from "io-ts"
import { UUID } from "io-ts-types/lib/UUID"

const RebateCalculationType = t.type({
  createdAt: maybe(LocalDateTime),
  expectedMileage: maybe(t.number),
  fleetRiskScore: maybe(t.number),
  mileageRebatePercentage: maybe(t.string),
  riskScoreRebatePercentage: maybe(t.number),
  totalMileage: maybe(t.string),
})

const RebateCalculationPeriodType = t.type({
  calculation: maybe(RebateCalculationType),
  endTime: maybe(LocalDateTime),
  id: UUID,
  startTime: maybe(LocalDateTime),
  timeZone: maybe(t.string),
})

const PeriodData = t.type({
  accumulatedExpectedMileage: maybe(t.number),
  accumulatedMileage: maybe(t.number),
  accumulatedRebate: maybe(t.number),
  date: LocalDateTime,
  expectedMileage: maybe(t.number),
  lossRatio: maybe(t.number),
  mileage: maybe(t.number),
  safetyScore: maybe(t.number),
})

const RebatesData = t.type({
  accumulatedExpectedMileage: maybe(t.number),
  accumulatedMileage: maybe(t.number),
  accumulatedRebate: maybe(t.number),
  changeInRebate: maybe(t.number),
  lossRatio: maybe(t.number),
  periods: t.readonlyArray(PeriodData),
  safetyScore: maybe(t.number),
  safetyScoreThreshold: maybe(t.number),
})

export type RebateCalculationPeriod = t.TypeOf<typeof RebateCalculationPeriodType>
export type RebateCalculation = t.TypeOf<typeof RebateCalculationType>
export type RebateSummaryPeriodData = t.TypeOf<typeof PeriodData>
export type RebatesSummaryData = t.TypeOf<typeof RebatesData>

export const makeRebateCalculation = cast(RebateCalculationPeriodType)
export const makeRebatesCalculationData = cast(RebatesData)
